import { useNavigationPanelContext } from '@app/components/NavigationPanelProvider';
import useMarketingSupportProjectSelectedAppSlug from '@app/features/project/hooks/useMarketingSupportProjectSelectedAppSlug';
import getProjectNavigationMap from './utils/getProjectNavigationMap';

const useProjectNavigation = () => {
    const { project, userRights, session, branch, badges, features } = useNavigationPanelContext();

    const { marketingSupportProjectSelectedAppSlug } = useMarketingSupportProjectSelectedAppSlug(project.id);

    return getProjectNavigationMap({
        project,
        userRights,
        session,
        branch,
        badges,
        features,
        marketingSupportProjectSelectedAppSlug,
    });
};

export default useProjectNavigation;
